import { Editor, posToDOMRect } from '@tiptap/react';
import { Range } from '@tiptap/core';
import { PopupPosition } from '../tiptapPopup';

export const getTiptapPopupPosition = (editor: Editor, range: Range): PopupPosition => {
    const rangeRect = posToDOMRect(editor.view, range.from, range.from);

    return {
        anchor: 'bottom',
        anchorRect: rangeRect,
        point: {
            x: rangeRect.x,
            y: rangeRect.y + rangeRect.height,
        },
    };
};
